import _createClass from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { NonInviteServerTransaction } from "../transactions";
import { UserAgentServer } from "./user-agent-server";
/**
 * SUBSCRIBE UAS.
 * @public
 */
export var SubscribeUserAgentServer = /*#__PURE__*/function (_UserAgentServer) {
  _inherits(SubscribeUserAgentServer, _UserAgentServer);
  var _super = _createSuper(SubscribeUserAgentServer);
  function SubscribeUserAgentServer(core, message, delegate) {
    var _this;
    _classCallCheck(this, SubscribeUserAgentServer);
    _this = _super.call(this, NonInviteServerTransaction, core, message, delegate);
    _this.core = core;
    return _this;
  }
  return _createClass(SubscribeUserAgentServer);
}(UserAgentServer);